// src/components/UserTable.jsx
import React, { useEffect, useState } from "react";
import API_BASE_URL from "../apiConfig";

function UserTable({ onClose }) {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);

  // Cargar usuarios del backend
  useEffect(() => {
  fetch(`${API_BASE_URL}/login-api/get_users.php`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          setUsuarios(data);
        } else {
          alert("No autorizado o error al cargar usuarios");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  const actualizarRol = (id, role) => {
  fetch(`${API_BASE_URL}/login-api/update_role.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ id, role }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          alert("Rol actualizado correctamente");
          setUsuarios((prev) =>
            prev.map((u) => (u.id === id ? { ...u, role } : u))
          );
        } else {
          alert("Error al actualizar el rol");
        }
      })
      .catch((err) => console.error(err));
  };

  if (loading) return <div>Cargando usuarios...</div>;

  return (
    <div
      style={{
        position: "fixed",
        top: "15%",
        left: "50%",
        transform: "translateX(-50%)",
        width: "60%",
        maxHeight: "70%",
        overflowY: "auto",
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 0 15px rgba(0,0,0,0.3)",
        zIndex: 400,
      }}
    >
      <h3 style={{ marginBottom: "15px", textAlign: "center" }}>
        👥 Usuarios registrados
      </h3>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "15px",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f5f5f5" }}>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>ID</th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>Correo</th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>Rol</th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>Acción</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map((u) => (
            <tr key={u.id}>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>{u.id}</td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>{u.correo}</td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>{u.role}</td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                <select
                  value={u.role}
                  onChange={(e) => actualizarRol(u.id, e.target.value)}
                >
                  <option value="admin">Admin</option>
                  <option value="analista">Analista</option>
                  <option value="usuario">Usuario</option>
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button
        onClick={onClose}
        style={{
          backgroundColor: "#6c757d",
          color: "white",
          border: "none",
          padding: "8px 12px",
          borderRadius: "6px",
          cursor: "pointer",
          display: "block",
          margin: "0 auto",
        }}
      >
        Cerrar
      </button>
    </div>
  );
}

export default UserTable;